import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useAdultModeQuery } from "@/hooks";
import MetaTags from "./index";
import config from "@/lib/config";
import routes from "@/lib/routes";
import { jsx as _jsx } from "react/jsx-runtime";
export function tags(step, adultMode) {
  var vod = {
    step1: {
      title: "会員登録 | SPOOX(スプークス)",
      keywords: "SPOOX,スプークス,動画配信,見放題,レンタル,会員登録",
      description: "SPOOX(スプークス)への会員登録はこちらから。スポーツや映画やアニメなど、様々な動画を配信中です。",
      og: {
        type: "article",
        url: "".concat(config.host.vod).concat(routes.signupStep(1))
      }
    },
    step2: {
      title: "メールアドレスの認証 | SPOOX(スプークス)",
      keywords: "SPOOX,スプークス,動画配信,見放題,レンタル,会員登録",
      description: "メールアドレスの認証。SPOOX(スプークス)では、スポーツや映画やアニメなど、様々な動画を配信中です。",
      og: {
        type: "article",
        url: "".concat(config.host.vod).concat(routes.signupStep(2))
      },
      robots: "noindex"
    },
    step3: {
      title: "会員情報の入力 | SPOOX(スプークス)",
      keywords: "SPOOX,スプークス,動画配信,見放題,レンタル,会員登録",
      description: "会員情報の入力。SPOOX(スプークス)では、スポーツや映画やアニメなど、様々な動画を配信中です。",
      og: {
        type: "article",
        url: "".concat(config.host.vod).concat(routes.signupStep(3))
      },
      robots: "noindex"
    },
    complete: {
      title: "会員登録完了 | SPOOX(スプークス)",
      keywords: "SPOOX,スプークス,動画配信,見放題,レンタル,会員登録",
      description: "会員登録完了。SPOOX(スプークス)では、スポーツや映画やアニメなど、様々な動画を配信中です。",
      og: {
        type: "article",
        url: "".concat(config.host.vod).concat(routes.signupComplete)
      },
      robots: "noindex"
    }
  };
  var adult = {
    step1: {
      title: "会員登録 | SPOOX EX(スプークスイーエックス)",
      keywords: "SPOOX EX,スプークスイーエックス,動画配信,見放題,レンタル,会員登録",
      description: "SPOOX EX(スプークスイーエックス)への会員登録はこちらから。様々なアダルト動画を配信中です。",
      og: {
        type: "article",
        url: "".concat(config.host.adult).concat(routes.signupStep(1))
      }
    },
    step2: {
      title: "メールアドレスの認証 | SPOOX EX(スプークスイーエックス)",
      keywords: "SPOOX EX,スプークスイーエックス,動画配信,見放題,レンタル,会員登録",
      description: "メールアドレスの認証。SPOOX EX(スプークスイーエックス)では、様々なアダルト動画を配信中です。",
      og: {
        type: "article",
        url: "".concat(config.host.adult).concat(routes.signupStep(2))
      },
      robots: "noindex"
    },
    step3: {
      title: "会員情報の入力 | SPOOX EX(スプークスイーエックス)",
      keywords: "SPOOX EX,スプークスイーエックス,動画配信,見放題,レンタル,会員登録",
      description: "会員情報の入力。SPOOX EX(スプークスイーエックス)では、様々なアダルト動画を配信中です。",
      og: {
        type: "article",
        url: "".concat(config.host.adult).concat(routes.signupStep(3))
      },
      robots: "noindex"
    },
    complete: {
      title: "会員登録完了 | SPOOX EX(スプークスイーエックス)",
      keywords: "SPOOX EX,スプークスイーエックス,動画配信,見放題,レンタル,会員登録",
      description: "会員登録完了。SPOOX EX(スプークスイーエックス)では、様々なアダルト動画を配信中です。",
      og: {
        type: "article",
        url: "".concat(config.host.adult).concat(routes.signupComplete)
      },
      robots: "noindex"
    }
  };

  if (adultMode) {
    return adult[step];
  } else {
    return vod[step];
  }
}
export default function SignUpMetaTags(_ref) {
  var step = _ref.step;

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      adultMode = _useAdultModeQuery.data.adultMode;

  var props = tags(step, adultMode);
  return /*#__PURE__*/_jsx(MetaTags, _objectSpread({}, props));
}